import type { IAdvertiserGridRow } from '@/Interfaces/Advertiser.interface';
import ArchivedChip from '@/components/Grid/ArchivedChip';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import ActionsCell from './components/ActionsCell';
import AdvertiserNameCell from './components/AdvertiserNameCell';
import AgencyCell from './components/AgencyCell';
import ClientCell from './components/ClientCell';
import StatusCell from './components/StatusCell';

const COLUMNS: GridColDef[] = [
  {
    field: 'name',
    flex: 2.5,
    headerName: 'Advertiser name',
    display: 'flex',
    renderCell: AdvertiserNameCell,
  },
  {
    field: 'id',
    flex: 0.5,
    headerName: 'ID',
  },
  {
    field: 'campaignsCount',
    flex: 1,
    headerName: 'Campaigns',
    sortable: false,
  },
  {
    field: 'client',
    flex: 2,
    headerName: 'Client',
    display: 'flex',
    renderCell: ClientCell,
    sortable: false,
  },
  {
    field: 'agency',
    flex: 2,
    headerName: 'Agency',
    display: 'flex',
    renderCell: AgencyCell,
    sortable: false,
  },
  {
    field: 'isActive',
    flex: 1,
    headerName: 'Status',
    sortable: false,
    display: 'flex',
    renderCell: ({ row, value, ...props }: GridRenderCellParams<IAdvertiserGridRow>) => {
      if (row.isArchived) {
        return <ArchivedChip />;
      }
      return <StatusCell value={value} row={row} {...props} />;
    },
  },
  {
    field: 'createdAt',
    flex: 1,
    headerName: 'Date Created',
    valueFormatter: value => dateToShortFormat(value),
  },
  {
    field: 'actions',
    flex: 1.5,
    headerName: 'Action',
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    renderCell: ActionsCell,
    sortable: false,
  },
];

export default COLUMNS;
